export default __webpack_public_path__ + "static/media/IBKneeflexionatmidswing2.dc798e7a.png";